import type { ReactNode } from 'react';
import { Monitor } from 'lucide-react';
import { cn } from '../../lib/cn';
import { Icon } from '../ui/icon';

export interface AmRechnerBearbeitenProps {
  /** Ein Satz, was sich dort bearbeiten lässt: „Anfragen anlegen, verschieben und abschließen geht am Rechner.“ */
  children?: ReactNode;
  className?: string;
}

/**
 * Seitenklasse „Am Rechner bearbeiten“ (README „Mobil“, M2): steht am Handy
 * über der Zusammenfassung ohne Eingaben. Der Wortlaut ist fest, in jeder App
 * derselbe. Ein ruhiger Hinweis, kein Callout: Den einen Callout der Ansicht
 * behalten Warnungen. Die Seite blendet ihn am Rechner aus (`md:hidden` oder
 * `useMobil`).
 */
export function AmRechnerBearbeiten({ children, className }: AmRechnerBearbeitenProps) {
  return (
    <div role="note" className={cn('flex gap-2.5', className)}>
      <Icon icon={Monitor} className="mt-0.5 text-highlight" />
      <div className="min-w-0">
        <div className="t-body-strong">Am Rechner bearbeiten</div>
        {children && <div className="t-small text-muted-foreground">{children}</div>}
      </div>
    </div>
  );
}
